/** IndexedDB 데이터베이스 설정 (sw.ts와 lib/db/index.ts 공유) */
export const DB_NAME = "ict-mobile-db";
// DB_VERSION 2: machineTemplates 테이블 추가 (Feature 288)
// DB_VERSION 3: idMapping 테이블 추가 (Feature 326)
export const DB_VERSION = 3;
